import { axiosClient } from "./axiosClient";

export const getScenarioNode = async (rootNodeId: number) => {
  return await axiosClient.get<ScenarioNode>(`/ScenarioNodes/getnode/${rootNodeId}`);
};
